// theme.state.ts




export interface ThemeState {
  theme: string;
}

export const initialThemeState: ThemeState = {
  theme: ''
};